import {tap} from 'rxjs/operators';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {environment} from '@env';

@Injectable()
export class TimingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now();
    return next
      .handle(req).pipe(
        tap(event => {
          if (event instanceof HttpResponse && environment.development) {
            const elapsed = Date.now() - started;
            // Cannot use the logger service here because it will create an infinite loop
            console.log(`${req.method} request for ${req.urlWithParams} took ${elapsed} ms.`);
          }
        }));
  }
}
